(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["gift-personalization"] && !Shopify.designMode) return;
  try {
    (() => {
    if (window.__personalizeFieldsBound) return;
    window.__personalizeFieldsBound = true;

    /**
     * The "How many?" stepper is this product's quantity control: it writes straight into
     * the buy form's quantity input, which the cart reads on submit.
     * @param {HTMLElement} counter - the [data-personalize-each] element
     * @param {number} requested
     */
    const setPieceCount = (counter, requested) => {
      const input = counter.querySelector('[data-count-input]');
      if (!(input instanceof HTMLInputElement)) return;
      const count = Math.min(Number(input.max) || 99, Math.max(1, Math.round(requested) || 1));
      input.value = String(count);
      const quantity = document.getElementById(counter.dataset.formId || '')?.querySelector('input[name="quantity"]');
      if (quantity instanceof HTMLInputElement) quantity.value = String(count);
    };

    document.addEventListener('click', (event) => {
      const button = event.target instanceof Element ? event.target.closest('[data-count-step]') : null;
      const counter = button?.closest('[data-personalize-each]');
      const input = counter?.querySelector('[data-count-input]');
      if (!button || !(counter instanceof HTMLElement) || !(input instanceof HTMLInputElement)) return;
      setPieceCount(counter, Number(input.value) + Number(button.getAttribute('data-count-step')));
    });

    document.addEventListener('change', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLInputElement) || !input.matches('[data-count-input]')) return;
      const counter = input.closest('[data-personalize-each]');
      if (counter instanceof HTMLElement) setPieceCount(counter, Number(input.value));
    });

    /**
     * Shows the product price with every ticked add-on included, for the selected variant.
     * @param {HTMLElement} section - the product section holding the price and the add-on boxes
     */
    const showAddOnPrice = (section) => {
      const boxes = Array.from(section.querySelectorAll('input[data-addon-prices]'));
      const container = Array.from(section.querySelectorAll('product-price')).find((el) => !el.closest('product-card'))?.querySelector('[ref="priceContainer"]');
      const variantId = boxes[0] && document.getElementById(boxes[0].getAttribute('form') || '')?.querySelector('input[name="id"]')?.value;
      if (!container || !variantId) return;
      const ticked = boxes.find((box) => box instanceof HTMLInputElement && box.checked);
      const prices = JSON.parse((ticked || boxes[0]).dataset.addonPrices || '{}')[variantId];
      if (!prices) return;
      const [price, compare] = ticked ? prices.slice(2) : prices.slice(0, 2);
      /** Swap the amount and keep the screen-reader prefix ("Sale price") in front of it. */
      const setAmount = (span, amount) => {
        if (!span || !amount) return;
        const prefix = span.querySelector('.visually-hidden');
        span.replaceChildren(...(prefix ? [prefix] : []), amount);
      };
      setAmount(container.querySelector('.price'), price);
      setAmount(container.querySelector('.compare-at-price'), compare);
    };

    document.addEventListener('change', (event) => {
      const box = event.target;
      if (!(box instanceof HTMLInputElement) || !box.matches('input[data-addon-prices]')) return;
      const section = box.closest('.shopify-section');
      if (!(section instanceof HTMLElement)) return;
      showAddOnPrice(section);

      // A variant change swaps in a fresh price from the server, without the add-on; put it back.
      const price = Array.from(section.querySelectorAll('product-price')).find((el) => !el.closest('product-card'));
      if (price && !price.hasAttribute('data-addon-watched')) {
        price.setAttribute('data-addon-watched', '');
        new MutationObserver(() => setTimeout(() => showAddOnPrice(section))).observe(price, { childList: true });
      }
    });

    document.addEventListener('input', (event) => {
      const input = event.target;
      if (!(input instanceof HTMLElement) || !input.matches('[data-personalize-count]')) return;
      const counter = input.parentElement?.querySelector('.personalize-field__count');
      if (counter) counter.textContent = `${input.value.length} / ${input.maxLength}`;
    });

    document.addEventListener('change', (event) => {
      const picker = event.target;
      if (!(picker instanceof HTMLInputElement) || !picker.matches('[data-personalize-upload]')) return;

      const field = picker.closest('.personalize-field');
      const previews = field?.querySelector('[data-personalize-previews]');
      const holder = field?.querySelector('[data-personalize-files]');
      const error = field?.querySelector('.personalize-field__error');
      if (!field || !previews || !holder) return;

      const maxFiles = Number(picker.dataset.maxFiles || 1);
      const maxMb = Number(picker.dataset.maxMb || 10);
      const label = picker.dataset.label || 'Photo';
      const files = Array.from(picker.files || []);

      const fail = (message) => {
        picker.value = '';
        picker.setCustomValidity(message);
        picker.reportValidity();
        if (error) {
          error.textContent = message;
          error.hidden = false;
        }
        previews.replaceChildren();
        holder.replaceChildren();
      };

      picker.setCustomValidity('');
      if (error) error.hidden = true;
      previews.replaceChildren();
      holder.replaceChildren();

      if (files.length > maxFiles) return fail(`Please choose up to ${maxFiles} photos.`);
      const tooBig = files.find((file) => file.size > maxMb * 1024 * 1024);
      if (tooBig) return fail(`"${tooBig.name}" is too large. Please keep each photo under ${maxMb} MB.`);

      files.forEach((file, index) => {
        // One line item property holds one file, so each photo gets its own named input.
        const transfer = new DataTransfer();
        transfer.items.add(file);
        const hidden = document.createElement('input');
        hidden.type = 'file';
        hidden.name = `properties[${maxFiles > 1 ? `${label} ${index + 1}` : label}]`;
        hidden.setAttribute('form', picker.dataset.formId || '');
        hidden.files = transfer.files;
        holder.append(hidden);

        const img = document.createElement('img');
        img.src = URL.createObjectURL(file);
        img.alt = file.name;
        img.width = 72;
        img.height = 72;
        previews.append(img);
      });
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
